import { c as _c } from "react/compiler-runtime";
import { RatingStats } from "@/entities/IProfile";
import UserPageRepRepsTableItem from "./UserPageRepRepsTableItem";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
export default function UserPageRepRepsTableBody(t0) {
  const $ = _c(9);
  const {
    reps,
    profile,
    canEditRep
  } = t0;
  let t1;
  if ($[0] !== canEditRep || $[1] !== profile || $[2] !== reps) {
    let t2;
    if ($[4] !== canEditRep || $[5] !== profile) {
      t2 = rep => <UserPageRepRepsTableItem key={rep.category} rep={rep} profile={profile} canEditRep={canEditRep} />;
      $[4] = canEditRep;
      $[5] = profile;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = reps.map(t2);
    $[0] = canEditRep;
    $[1] = profile;
    $[2] = reps;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <tbody className="tw-divide-y tw-divide-solid tw-divide-iron-800">{t1}</tbody>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}